export const LANGGRAPH_INTEGRATION_NAME = 'LangGraph' as const;
export const LANGGRAPH_ORIGIN = 'auto.ai.langgraph';
